import React from 'react';
import Button from '../../inputs/Button';
import Typography from '@mui/material/Typography';
import useEmotionStyles from '../../hooks/useEmotionStyles';
import List from '../List';
import Box from '@mui/material/Box';
var styles = function (theme) {
    var _a;
    return ({
        inserted: (_a = {
                background: 'rgba(34, 34, 34, 0.9)',
                padding: '40px 60px 60px'
            },
            _a[theme.breakpoints.down('sm')] = {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
            _a),
        titleText: {
            color: 'white',
            marginBottom: theme.spacing(2),
        },
    });
};
var AdvantagesList = function (_a) {
    var title = _a.title, advantages = _a.advantages, btnTitle = _a.btnTitle, _b = _a.inserted, inserted = _b === void 0 ? true : _b, onClick = _a.onClick;
    var cs = useEmotionStyles(styles);
    var rootClassName = inserted ? cs.inserted : '';
    return (React.createElement("div", { className: rootClassName },
        React.createElement(Typography, { variant: 'h3', className: cs.titleText }, title),
        React.createElement(Box, { pt: 2, pb: 2 },
            React.createElement(List, { items: advantages, size: 'lg', white: true })),
        React.createElement("div", null,
            React.createElement(Button, { onClick: onClick, fullWidth: true, variant: "contained", color: "primary", size: "large" }, btnTitle))));
};
export default AdvantagesList;
